import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  city: 'Córdoba'
}, {
  name: 'Carlos',
  city: 'Mendoza'
}, {
  name: 'Laura',
  city: 'Rosario'
}, {
  name: 'Jorge',
  city: 'Buenos Aires'
}, {
  name: 'Ana',
  city: 'Tucumán'
}, {
  name: 'Roberto',
  city: 'Santa Fe'
}, {
  name: 'Silvia',
  city: 'Mar del Plata'
}, {
  name: 'Florencia',
  city: 'La Plata'
}, {
  name: 'Martín',
  city: 'Salta'
}, {
  name: 'Patricia',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    // Rotation interval
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * PURCHASES.length);
        setCurrentPurchase(PURCHASES[randomIndex]);
        setIsVisible(true);
      }, 1000); // Wait for exit animation before showing new one
    }, 8000); // Show every 8 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-380">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-40 max-w-[300px] w-full" data-id="element-381">
          <div className="bg-white rounded-lg shadow-xl border-l-4 border-forest-600 p-4 flex items-start gap-3" data-id="element-382">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-383">
              <CheckCircle2 size={20} className="text-forest-600" data-id="element-384" />
            </div>
            <div data-id="element-385">
              <p className="text-sm font-medium text-gray-900" data-id="element-386">
                <span className="font-bold" data-id="element-387">{currentPurchase.name}</span> de{' '}
                {currentPurchase.city}
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-388">
                acaba de comprar el{' '}
                <span className="font-semibold text-forest-700" data-id="element-389">MEGAPACK</span>
              </p>
              <p className="text-[10px] text-gray-400 mt-1" data-id="element-390">
                Hace unos instantes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}